import { render } from "./QuickAddTime.vue?vue&type=template&id=58cd32c5&scoped=true"
import script from "./QuickAddTime.vue?vue&type=script&lang=js"
export * from "./QuickAddTime.vue?vue&type=script&lang=js"

import "./QuickAddTime.vue?vue&type=style&index=0&id=58cd32c5&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cd32c5"]])

export default __exports__